<template>
  <div class="flex justify-content-between d-none d-lg-flex d-xl-flex d-md-flex col-9">
    <div class="border-right text-center px-1 col-2">
      <label>Min.</label>
      <div class="info-text">{{ job.minimum_hours ? job.minimum_hours + 'h' : 'Not set' }}</div>
    </div>
    <div class="border-right col-3">
      <label>Moving Company:</label>
      <div class="info-text">{{ job.company && job.company.name }}</div>
    </div>
    <div class="border-right col-3">
      <label>Carrier:</label>
      <div class="info-text">{{ job.carrier && job.carrier.name }}</div>
    </div>
    <div class="border-right col-3" v-if="$_can('jobs.carrier.assign')">
      <label>Lead created by:</label>
      <div class="info-text">
        <p>
          {{ job.lead_created_by && job.lead_created_by.username }}
        </p>
      </div>
    </div>
    <div class="col-2">
      <label>Assigned:</label>
      <div class="info-text">
        <p>
          {{ job.cluster_user && job.cluster_user.username }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    job: {
      type: Object,
      default: () => {},
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/jobs/JobMoveInfo.vue